import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=45196f53&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"
import style0 from "./Goods.vue?vue&type=style&index=0&id=45196f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45196f53",
  null
  
)

export default component.exports